(function () {
  /**
   * @ngdoc module
   * @name akitabox.mobile.directives.textCard
   */
  angular
    .module("akitabox.mobile.directives.textCard")
    .directive("abmTextCard", AbmTextCardDirective);

  /**
   * @ngdoc directive
   * @module akitabox.mobile.directives.textCard
   * @name AbmTextCardDirective
   *
   * @restrict E
   *
   * @description
   * `<abm-text-card>` is a card with a textarea and an mdDialog that opens on edit.  The card has a
   * Show More or Show Less toggle for text that exceeds MAX_LINES.
   *
   * @usage
   *  <abm-text-card
   *          ng-model="vm.building.description"
   *          placeholder="'No' + ($root.MODEL.BUILDING.FIELDS.DESCRIPTION | lowercase) ' available'"
   *          ng-cloak
   *          readonly>
   *      <label ng-bind="$root.MODEL.BUILDING.FIELDS.DESCRIPTION"></label>
   *  </abm-text-card>
   *
   * @ngInject
   */
  function AbmTextCardDirective($sanitize, $timeout, $window, Utils) {
    return {
      restrict: "E",
      templateUrl: "app/mobile/directives/text-card/text-card.html",
      controller: "AbmTextCardController",
      controllerAs: "vm",
      bindToController: true,
      transclude: {
        label: "?label",
      },
      link: postLink,
      scope: {
        label: "@?",
        onSave: "&?",
        ngModel: "=?",
        ngDisabled: "&?",
        ngRequired: "&?",
        ngReadonly: "&?",
        onDelete: "&?",
        onSend: "&?",
        canDelete: "&?",
        canSendToRequester: "&?",
        emailRecipient: "=?",
        showActions: "=?",
      },
    };

    function postLink($scope, $element, attrs, vm) {
      // Constants
      var MAX_LINES = 7;
      var CONTENT_MARGINS = 48;
      var DEFAULT_FONT_SIZE = 18;
      var TEXT_STYLES = {
        "font-weight": "lighter",
        "word-wrap": "break-word",
      };

      // Attributes
      vm.disabled = angular.isDefined(attrs.disabled);
      vm.readonly = angular.isDefined(attrs.readonly);
      vm.required = angular.isDefined(attrs.required);
      vm.placeholder = attrs.placeholder || "Not specified";

      vm.value = null;
      vm.editable = !vm.readonly && !vm.disabled;
      vm.fontSize = "0px";

      // Determine which callbacks the user provided
      vm.hasSave = !angular.isEmpty(attrs.onSave);
      vm.hasDelete = !angular.isEmpty(attrs.onDelete);
      vm.hasSend = !angular.isEmpty(attrs.onSend);

      // Functions
      vm.toggleFullText = toggleFullText;
      vm.updateContent = updateContent;

      // UI Elements
      var $label;
      var $value;

      $timeout(function () {
        onLoad();
      });

      function onLoad() {
        // get the label and value
        findElements();

        // add star if required
        evaluateRequired();

        updateContent();

        $scope.$watch("vm.ngDisabled()", function (value) {
          if (angular.isDefined(value)) {
            vm.disabled = value;
            vm.editable = !vm.readonly && !vm.disabled;
          }
        });

        $scope.$watch("vm.ngReadonly()", function (value) {
          if (angular.isDefined(value)) {
            vm.readonly = value;
            vm.editable = !vm.readonly && !vm.disabled;
          }
        });

        $scope.$watch("vm.ngRequired()", function (value) {
          if (angular.isDefined(value)) {
            vm.required = value;
            evaluateRequired();
          }
        });

        $scope.$watch("vm.canDelete()", function (value) {
          if (angular.isDefined(value)) {
            vm.deletable = value;
          }
        });

        $scope.$watch("vm.canSendToRequester()", function (value) {
          if (angular.isDefined(value)) {
            vm.sendToRequester = value;
          }
        });
      }

      function findElements() {
        var $labels = $element.find("label");
        var $values = $element.find("abm-text-value");
        var bounds = $element.parent()[0].getBoundingClientRect();

        vm.width = bounds.width - CONTENT_MARGINS;

        // Get first label
        $label = angular.element($labels[0]);
        if (angular.isEmpty(vm.label)) vm.label = $label.text();

        // Get text value
        if ($values.length > 0) $value = angular.element($values[0]);
      }

      function evaluateRequired() {
        if (vm.required) {
          $label.addClass("required");
        } else {
          $label.removeClass("required");
        }
      }

      function toggleFullText() {
        vm.expanded = !vm.expanded;
        updateContent();
      }

      function updateContent() {
        $timeout(function () {
          vm.showPlaceholder = !$value || angular.isEmpty(vm.ngModel);
          if (vm.showPlaceholder) {
            return vm.placeholder;
          }
          vm.value = $sanitize(vm.ngModel.split("\n").join("<br/>"));
          return vm.value;
        }).then(function (content) {
          setContentHeight(content);
        });
      }

      function setContentHeight(newValue) {
        // get the font size
        var computedStyles = $window.getComputedStyle($value[0]);
        var fontPixelSize = parseInt(
          computedStyles.getPropertyValue("font-size"),
          10
        );
        if (angular.isEmpty(fontPixelSize)) {
          fontPixelSize = DEFAULT_FONT_SIZE;
        }
        vm.fontSize = fontPixelSize + "px";

        // determine the constrained height
        var fontHeight = Utils.getFontHeight(
          fontPixelSize,
          "px",
          null,
          "lighter"
        );
        var constrainedHeight = fontHeight * MAX_LINES;

        // determine the unconstrained height
        var fullHeight = Utils.getContextualFontHeight(
          vm.fontSize,
          vm.width,
          TEXT_STYLES,
          newValue
        );

        if (fullHeight > constrainedHeight) {
          // show the toggle
          vm.moreToShow = true;
        } else {
          // don't show the toggle
          vm.moreToShow = false;
          if (vm.expanded) {
            vm.expanded = false;
          }
        }
        // set the content height
        vm.contentHeight = vm.expanded ? "100%" : constrainedHeight + "px";
      }
    }
  }
})();
